module.exports = __webpack_public_path__ + "img/hr-dirt-2.656ab5bc.png";